export const activityConstants = {
  DAILY_STATUS_REQUEST: "ACTIVITY_DAILY_STATUS_REQUEST",
  DAILY_STATUS_SUCCESS: "ACTIVITY_DAILY_STATUS_SUCCESS",
  DAILY_STATUS_FAILURE: "ACTIVITY_DAILY_STATUS_FAILURE",
  WEEKLY_STATUS_REQUEST: "ACTIVITY_WEEKLY_STATUS_REQUEST",
  WEEKLY_STATUS_SUCCESS: "ACTIVITY_WEEKLY_STATUS_SUCCESS",
  WEEKLY_STATUS_FAILURE: "ACTIVITY_WEEKLY_STATUS_FAILURE",
  SET_ACTIVITY_FREQUENCY: "SET_ACTIVITY_FREQUENCY",
  SET_DETAIL_ITEM: "SET_DETAIL_ITEM",
  TIMELINE_REQUEST: "APPLIANCES_TIMELINE_REQUEST",
  TIMELINE_SUCCESS: "APPLIANCES_TIMELINE_SUCCESS",
  TIMELINE_FAILURE: "APPLIANCES_TIMELINE_FAILURE",
  OFF_ALERTS_REQUEST: "OFF_ALERTS_REQUEST",
  OFF_ALERTS_SUCCESS: "OFF_ALERTS_SUCCESS",
  OFF_ALERTS_FAILURE: "OFF_ALERTS_FAILURE",
  SET_DAILY_OFF_ALERTS_TOGGLE: "SET_DAILY_OFF_ALERTS_TOGGLE",
  SET_WEEKLY_OFF_ALERTS_TOGGLE: "SET_WEEKLY_OFF_ALERTS_TOGGLE",
};
